import { Component, Input, TemplateRef } from '@angular/core';
import { NgClass, NgTemplateOutlet, NgIf } from '@angular/common';

@Component({
  selector: 'app-dropdown-container',
  standalone: true,
  imports: [NgClass, NgTemplateOutlet, NgIf],
  templateUrl: './dropdown-container.component.html',
  styleUrls: ['./dropdown-container.component.css']
})
export class DropdownContainerComponent {
  @Input() titleTemplate: TemplateRef<any> | null = null;
  @Input() titleTemplateContext: any = {};
  isOpen: boolean = false;

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }
}
